<template>
  <footer class="footer is-warning">
    <p class="text">
      Made by <a href="https://jntech.pro/" target="_blank">JN TECHNOLOGY</a> -
      <Popup class="popup" />
    </p>
  </footer>
</template>

<script>
import Popup from "../components/Popup";
export default {
  components: {
    Popup
  }
};
</script>

<style lang="scss" scoped>
.text {
  text-align: left;
}
.popup {
  display: inline-flex;
}
</style>
